module.exports = {
      id: "bookmark-outline-usage",
      viewBox: "0 0 24 36",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#bookmark-outline",
      toString: function () {
        return this.url;
      }
    }